import { useEffect } from "react";
import { useLoaderData } from "react-router-dom";

const ADD_VENDOR_URL = process.env.REACT_APP_ADD_VENDOR_SCREEN;

/**
 *
 * @param {Object} props
 * @param {Function} props.closeCallback
 * @returns
 */
const AddVendor = ({ closeCallback }) => {
  const { client_url, corporation_id, nimbleAuthID } = useLoaderData();

  useEffect(() => {
    window.addEventListener("message", handleMessage);
    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  /**
   *
   * @param {MessageEvent} event
   * @returns
   */
  function handleMessage(event) {
    let message = event.data;
    if (message.source !== "nimbleproperty") return;
    if (message["closePopup"]) closeCallback();
  }

  return (
    <iframe
      src={`${ADD_VENDOR_URL}/payable/launchscreen/vendordialog/${
        client_url.split(".")[0]
      }/${nimbleAuthID}/010000000000000000000000000000000330/${corporation_id}/popupid`}
      width={"100%"}
      height={"100%"}
      style={{ border: "none" }}
    />
  );
};

export default AddVendor;
